/** Стабильный цвет и буква для вкладки браузера (фавикон + title). */

export const DEFAULT_TAB_TITLE = 'Диобуч';
export const DEFAULT_FAVICON_HREF = '/static/favicon.png';

const PALETTE = [
  '#2563eb', // blue
  '#059669', // green
  '#d97706', // amber
  '#dc2626', // red
  '#7c3aed', // violet
  '#0891b2', // cyan
  '#db2777', // pink
  '#4f46e5', // indigo
  '#65a30d', // lime
  '#ea580c', // orange
];

const SECTION_COLORS = {
  default: '#64748b',
  teacher: '#2563eb',
  catalog: '#0891b2',
  billing: '#d97706',
  konspekt: '#7c3aed',
  tasks: '#059669',
  collab: '#db2777',
  work: '#4f46e5',
  trainers: '#ea580c',
  profile: '#64748b',
  auth: '#64748b',
  print: '#64748b',
};

function hashString(str) {
  let h = 0;
  const s = String(str || '');
  for (let i = 0; i < s.length; i += 1) {
    h = (h * 31 + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

/** Стабильный цвет: для student:* — из палитры по id; иначе фикс. цвет раздела. */
export function colorForKey(colorKey) {
  const key = String(colorKey || 'default');
  if (key.startsWith('student:')) {
    return PALETTE[hashString(key) % PALETTE.length];
  }
  if (SECTION_COLORS[key]) return SECTION_COLORS[key];
  return PALETTE[hashString(key) % PALETTE.length];
}

/** 1–2 символа для фавикона (кириллица ок). */
export function badgeFromLabel(label, fallback = 'D') {
  const t = String(label || '').trim();
  if (!t) return fallback;
  const letters = t.match(/[A-Za-zА-Яа-яЁё0-9]/g);
  if (!letters || !letters.length) return fallback;
  if (letters.length === 1) return letters[0].toUpperCase();
  // Одна буква читается лучше на 16px
  return letters[0].toUpperCase();
}

export function buildFaviconDataUrl({ badge, colorKey }) {
  const size = 32;
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (!ctx) return DEFAULT_FAVICON_HREF;

  const color = colorForKey(colorKey);
  ctx.clearRect(0, 0, size, size);
  ctx.beginPath();
  ctx.arc(size / 2, size / 2, size / 2 - 1, 0, Math.PI * 2);
  ctx.fillStyle = color;
  ctx.fill();

  const letter = (badge || 'D').slice(0, 2);
  ctx.fillStyle = '#ffffff';
  ctx.font = `bold ${letter.length > 1 ? 14 : 18}px system-ui, Segoe UI, sans-serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(letter, size / 2, size / 2 + 1);

  return canvas.toDataURL('image/png');
}

function ensureIconLink() {
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/png';
    document.head.appendChild(link);
  }
  return link;
}

/**
 * Применить title и фавикон.
 * @param {{ title?: string, badge?: string, colorKey?: string } | null} identity
 */
export function applyTabIdentity(identity) {
  if (!identity) {
    document.title = DEFAULT_TAB_TITLE;
    const link = ensureIconLink();
    link.href = DEFAULT_FAVICON_HREF;
    return;
  }
  const title = (identity.title || '').trim() || DEFAULT_TAB_TITLE;
  document.title = title;
  const badge = identity.badge || badgeFromLabel(title);
  const colorKey = identity.colorKey || 'default';
  const link = ensureIconLink();
  link.href = buildFaviconDataUrl({ badge, colorKey });
}

export function restoreDefaultTabIdentity() {
  applyTabIdentity(null);
}

/** Кабинет преподавателя: учитель, staff или админ. */
export function isTeacherLike(user) {
  return Boolean(user?.is_teacher || user?.is_staff || user?.is_admin);
}
